import { Stack } from "@fluentui/react";
import { useCallback } from "react";
import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";

import { buildTermsColumns } from "./fields/Terms.columns";
import { buildTermsFilters } from "./fields/Terms.filters";

import { FilterParamsType } from "@/common/types/ListFromApi.types";
import { Card } from "@/components/Shared/Card";
import { useGetServices } from "@/core/libs/api/react-query/hook/use-get-services";
import { useGetTerms } from "@/core/libs/api/react-query/hook/use-get-terms";
import { ListData } from "@/core/libs/list-data/lib";
import { useURLFilter } from "@/hooks/useUrlFilter";
import { formatToSelect } from "@/utils/FormatToSelect";

interface ListTermsProps {
  termType?: "ASSOCIATION" | "CHANGE_OF_OWNERSHIP";
  title: string;
}

function ListTerms({ title, termType }: ListTermsProps): JSX.Element {
  const { changeUrlParams, urlParams } = useURLFilter();
  const { termsList, isLoadingTermsList } = useGetTerms({
    params: { ...urlParams.params, termType },
    urlString: "terms",
    method: "GET"
  });

  const { servicesList, isLoadingServicesList } = useGetServices({
    method: "GET"
  });

  const servicesFormatted = formatToSelect(servicesList);
  const navigate = useNavigate();

  const handleAccountRequest = useCallback(
    (filterParams?: FilterParamsType) => {
      changeUrlParams(filterParams);
    },
    [changeUrlParams]
  );

  return (
    <Stack styles={{ root: { width: "100%" } }}>
      <Helmet>
        <title>{title} - Libertas</title>
      </Helmet>

      <Stack tokens={{ childrenGap: 15 }}>
        <h2 className="ms-fontSize-24">{title}</h2>
        <Card>
          <ListData
            headerAction={undefined}
            headerText={title}
            isLoadingList={isLoadingTermsList}
            items={termsList || []}
            columns={buildTermsColumns({
              hasActions: false,
              navigate
            })}
            menuItems={termsList}
            _paginate={handleAccountRequest}
            filters={buildTermsFilters({
              servicesList: servicesFormatted,
              isLoadingServicesList
            })}
            hasFilters
            isDefaultFilterVisible
          />
        </Card>
      </Stack>
    </Stack>
  );
}

export default ListTerms;
